import messagesUS from './en-US.json'
import messagesES from './es-ES.json'
import messagesJA from './ja-JA.json'

export const messages = {
  ["en-US"] : messagesUS,
  ["es-ES"]: messagesES,
  ["ja-JA"]: messagesJA
}
